module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAE0SURBVDhPjZShcsJAFEWZDhKJQCIQEZVIREVlJRJZUYngDyoRFf2Afgqin4Co7DAIBKIiooKZLOft3mSYLC9wZt7sLve8AJtNevdSVdWK+g4hDPVRN8hL5AjzjT72QZpTJ/VY01bRdRBeWg0HhpHiHMIZUhltUEOhOAfhsdVQUlPFOTiFrhph/s8wU5xDOEL6jTYwP1FzxTk4Q4SfpCdYLxTnkA8Q7MY1sF4qziHvI2ySmmD9rvg6CF9yI6w/FLk8UO2btdPow8Xt/2zT9yRYvyn2wbOtbnaOefdW1+COES9vqp25Z8U+SHYajrELmNtR8k9DjUmSI8z/GPyDWoP0pJ8XYX6gJop9kNoPn22U/yzVIL6mloQaB4p9EJv3g8H69jvCQFyrx5q63xGXIH9S+xDC+Ax+EM/qIPqCzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/u1675.png
// module id = SGY5
// module chunks = 0